/* Show a recoverable error beside the native button without changing Shrine's cart code. */
(() => {
  'use strict';
  if (window.__veloraNativeCartError) return;
  window.__veloraNativeCartError = true;
  const message = 'Nem sikerült a kosárba tenni. Próbáld újra.';
  let attempted = null;
  function errorFor(button) {
    const anchor = button.closest('.product-form__quantity-and-btn') || button;
    let error = anchor.nextElementSibling?.matches('[data-velora-cart-error]') ? anchor.nextElementSibling : null;
    if (!error) {
      error = document.createElement('p');
      error.className = 'velora-cart-error';
      error.setAttribute('data-velora-cart-error', '');
      error.setAttribute('role', 'alert');
      anchor.insertAdjacentElement('afterend', error);
      const shrineError = button.closest('product-form')?.querySelector('.product-form__error-message-wrapper');
      if (shrineError) new MutationObserver(() => {
        // Shrine may reveal its own server error after receiving the same failed response.
        if (!error.hidden && !shrineError.hidden) shrineError.hidden = true;
      }).observe(shrineError, { attributes: true, attributeFilter: ['hidden'] });
    }
    return error;
  }
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!form.matches('product-form form[action*="/cart/add"]')) return;
    const button = form.querySelector('button[name="add"]');
    if (!button) return;
    attempted = { form, button };
    errorFor(button).hidden = true;
  }, true);
  const originalFetch = window.fetch;
  window.fetch = function(input, options) {
    // Shrine submits FormData. JSON bundle, charm and gift requests keep their own error handling.
    let target = null;
    const body = options?.body;
    try {
      const url = new URL(typeof input === 'string' ? input : input.url, location.href);
      if (url.origin === location.origin && /\/cart\/add(?:\.js)?\/?$/.test(url.pathname) &&
          body instanceof FormData && attempted &&
          [body.get('id'), body.get('items[0][id]')].some(id =>
            id !== null && String(id) === attempted.form.querySelector('[name="id"]')?.value)) {
        target = attempted;
        attempted = null;
      }
    } catch (_) { /* Unrelated fetches are passed through unchanged. */ }
    const fail = (generic = true) => {
      if (!target?.button.isConnected) return;
      if (generic) {
        const error = errorFor(target.button);
        error.textContent = message;
        error.hidden = false;
        const shrineError = target.form.closest('product-form').querySelector('.product-form__error-message-wrapper');
        if (shrineError) shrineError.hidden = true;
      }
      target.button.disabled = false;
      target.button.setAttribute('aria-disabled', 'false');
      target.button.classList.remove('loading');
      target.button.querySelector('.loading-overlay__spinner')?.classList.add('hidden');
    };
    return originalFetch.apply(this, arguments).then(async (response) => {
      if (target) {
        try {
          const data = await response.clone().json();
          const status = response.ok ? Number(data?.status) : response.status;
          // Valid 4xx JSON carries Shopify's specific error, which Shrine displays itself.
          if (!response.ok || data?.status) fail(status >= 500 && status < 600);
        } catch (_) { fail(); }
      }
      return response;
    }, (error) => { fail(); throw error; });
  };
})();
